"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupSwagger = setupSwagger;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const express_basic_auth_1 = tslib_1.__importDefault(require("express-basic-auth"));
const constants_1 = require("./constants");
/**
 * Sets up Swagger documentation for a NestJS application.
 */
function setupSwagger(app, serviceName, moduleName, gatewayUrl) {
    // Configure Swagger document metadata
    const config = new swagger_1.DocumentBuilder()
        .setTitle(`${serviceName} API`) // Title of the API documentation
        .setDescription(`API documentation for ${serviceName}`) // Description of the API
        .setVersion("1.0") // Version of the API
        .addBearerAuth(
    // ✅ This enables the Authorization header
    {
        type: "http",
        scheme: "bearer",
        bearerFormat: "JWT",
        name: "Authorization",
        description: "Enter JWT token",
        in: "header",
    }, "access-token" // This name must match the `@ApiBearerAuth()` decorator
    )
        .addServer(`${gatewayUrl}/${constants_1.iirm}/${moduleName}`)
        .build();
    // Create the Swagger document
    const document = swagger_1.SwaggerModule.createDocument(app, config);
    // Protect Swagger UI with basic authentication
    app.use("/api/docs", (0, express_basic_auth_1.default)({
        users: { admin: "password123" }, // Replace with your desired username and password
        challenge: true, // Enables the browser's built-in authentication dialog
    }));
    // Set up the Swagger UI at the specified endpoint
    swagger_1.SwaggerModule.setup("api/docs", app, document);
}
